import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import type { ChargeWithInvoice, DashboardData } from '../../../services/dashboard.service';
import { formatDashboardCurrency, formatDashboardDate } from '../dashboard-utils';

@Component({
  selector: 'app-dash-recent-payments',
  templateUrl: './dash-recent-payments.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterLink],
  styles: [':host { display: block; height: 100%; }']
})
export class DashRecentPaymentsWidgetComponent {
  data = input<DashboardData | null>(null);

  readonly formatCurrency = formatDashboardCurrency;
  readonly formatDate = formatDashboardDate;

  trackCharge(_: number, c: ChargeWithInvoice): number {
    return c.id ?? 0;
  }
}
